<ng-template #headerTemplate>
  <app-system-header></app-system-header>
</ng-template>

@if (systems$ | async; as systems) {
<app-system-tab-strip [systems]="systems" [activeSystemId]="activeSystemId" [childPath]="childPath"></app-system-tab-strip>
}

<div class="system-nav">
  <a [routerLink]="['questionnaire']" queryParamsHandling="merge" [routerLinkActive]="['active-nav']">design parameters</a>
  <app-separator></app-separator>
  <a [routerLink]="['recommendation']" queryParamsHandling="merge" [routerLinkActive]="['active-nav']"> system summary </a>
</div>
<app-separator></app-separator>
<router-outlet (activate)="onRouterItemChange()"></router-outlet>
